<template>
    <div>
        <div
            v-if="canShow"
        >
            <span
                :class="badgeClasses"
                style="color: #fff;"
            >
                {{ getDealTasksCompleted(instance, teamId).length }} / {{ getDealTasks(instance, teamId).length }}
            </span>
            <ui-popover
                v-if="getDealTasks(instance, teamId).length > 0"
                class="custom-popover arrow"
                open-on="hover"
                :constrain-to-scroll-parent="false"
                position="left"
                offset="0,10"
            >
                <div class="popover-inner">
                    <div class="title">Job Card</div>
                    <div class="popover-body" style="padding: 1rem;">
                        <table class="table table-sm preparation-tasks-popover-table" style="margin-bottom: 0; font-size: .8rem; table-layout: auto;">
                            <tr v-for="job in getDealTasks(instance, teamId)">
                                <td>
                                    {{ job.title }}
                                    <div style="font-size: .8rem; color: #999;">{{ job.description }}</div>
                                    <task-children style="font-size: .8rem; color: #999;" v-if="job.children && job.children.length > 0" :task="job"></task-children>
                                </td>
                                <td style="width: 10%;">
                                    <span v-if="job.completed_at" class="material-icons" style="color: green;">check</span>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </ui-popover>
        </div>
        <slot
            v-else
            name="non-retail"
        />
    </div>
</template>

<style lang="scss" scoped>
    .custom-popover .popover-body {
        max-height: 45vh;
        overflow-y: auto;
    }
</style>

<script>
    import { DealLifeCycleStatuses } from '../../classes/Api/Deal';
    import { TaskPercentageDisplay } from '../mixins/TaskPercentageDisplay'
    import TaskChildren from "./TaskChildren.vue";

    export default {
        components: {TaskChildren},
        mixins: [TaskPercentageDisplay],
        props: {
            instance: {
                type: Object,
                required: true
            },
            teamId: {
                type: Number,
                required: false
            },
            badgeClasses: {
                type: String,
                required: false,
                default: 'badge badge-secondary'
            }
        },
        data() {
            return {
                DealLifeCycleStatuses
            }
        },
        computed: {
            canShow() {
                return (
                    (!this.instance.deal || this.instance.deal && this.instance.deal.life_cycle_status < DealLifeCycleStatuses.COMPLETED) &&
                    this.getDealTasks(this.instance, this.teamId).length > 0
                )
            }
        }
    }
</script>